import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../services/apis";
import { Button, Modal, Table } from "semantic-ui-react";
import {
  ActionButtons,
  AddModuloModalContainer,
  Bottom,
  ButtonsWrapper,
  Container,
  ModalActions,
  ModalContainer,
  ModuloHeader,
  NumberInput,
  TitleInput,
} from "./styles";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { RiDeleteBinLine } from "react-icons/ri";
import CursosSelector from "../../../components/Admin/CursosSelector";
import { FaRegEdit } from "react-icons/fa";
import Back from "../Back";

export const MBAListOne = props => {
  const [mba, setMba] = useState([]);
  const [descricao, setDescricao] = useState(mba.descricao);
  const [idCombo, setIdCombo] = useState("");
  const [idCurso, setIdCurso] = useState("");
  const [dataValidade, setDataValidade] = useState(mba.data_validade);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(null);
  const [moduleClicked, setModuleClicked] = useState(null);
  const [modalModuloId, setModalModuloId] = useState(null);
  const [isAddModuloOpen, setIsAddModuloOpen] = useState(false);
  const [selectedModalCourse, setSelectedModalCourse] = useState(0);
  const [addModuloModalTitulo, setAddModuloModalTitulo] = useState([]);
  const [addModuloModalDate, setAddModuloModalDate] = useState([]);
  const [isAddLiveModalOpen, setIsAddLiveModelOpen] = useState();
  const [addLiveDescricao, setAddLiveDescricao] = useState("");
  const [addLiveLink, setAddLiveLink] = useState("");
  const [addLiveDate, setAddLiveDate] = useState("");
  const [addLiveTipo, setAddLiveTipo] = useState("youtube_live");
  const [addLiveFile, setAddLiveFile] = useState("");
  const [updateLiveId, setUpdateLiveId] = useState("");

  useEffect(() => {
    setDataValidade(mba.data_validade);
  }, [mba]);

  const id = props.match.params.id;

  const loadMba = () => {
    api.get(`/admin/mba/${id}`).then(response => setMba(response.data));
  };

  useEffect(() => {
    setDescricao(mba.descricao);
    setIdCombo(mba.id_combo);
    setIdCurso(mba.id_curso);
  }, [mba]);

  useEffect(() => {
    loadMba();
  }, [id]);

  //atualizar modulo
  const handleAtualizarOrdemCursos = async moduloId => {
    const modulo = mba.mbaModulos.find(modulo => modulo.id === moduloId);

    const orders = modulo.moduloCursos
      .sort((a, b) => a.order - b.order)
      .map(curso => curso.id_curso);

    return api
      .put("/admin/mba/change-cursos-order", {
        id_modulo: moduloId,
        orders,
      })
      .catch(error => {
        throw error;
      });
  };

  const handleAtualizarModulo = async moduloId => {
    const modulo = mba.mbaModulos.find(modulo => modulo.id === moduloId);

    return api
      .put(`/admin/mba/att-modulo/${modulo.id}`, {
        titulo: modulo.titulo,
        data_liberacao: modulo.data_liberacao,
      })
      .catch(error => {
        throw error;
      });
  };

  const handleRefreshModuloAtualizado = async moduloId => {
    try {
      Promise.all([
        handleAtualizarOrdemCursos(moduloId),
        handleAtualizarModulo(moduloId),
      ]).then(async () => {
        const logs = {
          local: `admin/mba/list/${id}`,
          texto: `Realizou modificações no módulo: (${moduloId}) pertencente ao MBA: ${id})`,
        };
        await api.post("system_logs", {
          acao: JSON.stringify(logs),
        });
        swal("Módulo Alterado", "", "success");
      });
    } catch (error) {
      const logs = {
        local: `admin/mba/list/${id}`,
        texto: `Tentou realizar modificações no módulo (${moduloId}) pertencente ao MBA: ${id}) - Erro: ${error}`,
      };
      await api.post("system_logs", {
        acao: JSON.stringify(logs),
      });
      swal(
        "Houve um erro ao atualizar o módulo",
        "Favor contactar TI",
        "error"
      );
    }
  };

  //atualizar MBA inteiro
  const handleAtualizarOrdemModulos = async () => {
    const orders = mba.mbaModulos
      .sort((a, b) => a.order - b.order)
      .map(modulo => modulo.id);

    try {
      api
        .put("/admin/mba/change-modulos-order", {
          id_mba: id,
          orders,
        })
        .then(async () => {
          const logs = {
            local: `admin/mba/list/${id}`,
            texto: `Realizou modificações na ordem dos módulos do MBA: ${id}`,
          };
          await api.post("system_logs", {
            acao: JSON.stringify(logs),
          });
        });
    } catch (error) {
      const logs = {
        local: `admin/mba/list/${id}`,
        texto: `Tentou realizar modificações na ordem dos módulos do MBA: ${id}) - Erro: ${error}`,
      };
      await api.post("system_logs", {
        acao: JSON.stringify(logs),
      });
      swal("Erro ao ordenar módulos", "Favor contactar TI", "error");
    }
  };

  const handleAtualizarInfoMBA = async () => {
    try {
      api
        .put(`/admin/mba/att-mba/${id}`, {
          descricao,
          id_combo: idCombo,
          id_curso: idCurso,
        })
        .then(async () => {
          const logs = {
            local: `admin/mba/list/${id}`,
            texto: `Atualizou informações do MBA: ${id}, com a seguinte descrição: ${descricao}`,
          };
          await api.post("system_logs", {
            acao: JSON.stringify(logs),
          });
        });
    } catch (error) {
      const logs = {
        local: `admin/mba/list/${id}`,
        texto: `Tentou modificar informações do MBA: ${id}, com a seguinte descrição: ${descricao} - Erro: ${error}`,
      };
      await api.post("system_logs", {
        acao: JSON.stringify(logs),
      });
      swal(
        "Erro ao modificar as informações do MBA",
        "Favor contactar TI",
        "error"
      );
    }
  };

  const handleAtualizarTempoAcesso = async () => {
    try {
      api
        .put(`/admin/mba/atualiza-tempo-acesso/${id}`, {
          novaData: dataValidade,
        })
        .then(async () => {
          const logs = {
            local: `admin/mba/list/${id}`,
            texto: `Atualizou o tempo de acesso do MBA: ${id}`,
          };
          await api.post("system_logs", {
            acao: JSON.stringify(logs),
          });
        });
    } catch (error) {
      const logs = {
        local: `admin/mba/list/${id}`,
        texto: `Tentou atualizar o tempo de acesso do MBA: ${id} - Erro: ${error}`,
      };
      await api.post("system_logs", {
        acao: JSON.stringify(logs),
      });
      swal(
        "Erro ao atualizar o tempo de acesso do MBA",
        "Favor contactar TI",
        "error"
      );
    }
  };

  const handleUpdateMBA = () => {
    Promise.all([
      handleAtualizarOrdemModulos(),
      handleAtualizarInfoMBA(),
      handleAtualizarTempoAcesso(),
    ])
      .then(() => {
        loadMba();
        swal("MBA Atualizado com sucesso", "", "success");
      })
      .catch(() => {
        swal("Erro ao atualizar MBA", "", "error");
      });
  };

  const handleChangeDataLiberacao = (moduloId, value) => {
    const copyMBA = { ...mba };

    copyMBA.mbaModulos.find(modulo => modulo.id === moduloId).data_liberacao =
      value;

    setMba(copyMBA);
  };

  const handleCursosOrdemChange = (idModulo, idCurso, value) => {
    const updatedMba = { ...mba };

    updatedMba.mbaModulos
      .find(modulo => modulo.id === idModulo)
      .moduloCursos.find(curso => curso.id_curso === idCurso).order = value;

    setMba(updatedMba);
  };

  const handleModuloOrdemChange = (moduloId, value) => {
    const updatedMba = { ...mba };

    updatedMba.mbaModulos.find(modulo => modulo.id === moduloId).order = value;

    setMba(updatedMba);
  };

  const handleTitleChange = (value, moduloId) => {
    const updatedMba = { ...mba };

    updatedMba.mbaModulos.find(modulo => modulo.id === moduloId).titulo = value;

    setMba(updatedMba);
  };

  const handleRemoveCourse = (id_modulo, id_course) => {
    api
      .put(`/admin/mba/remove-modulo-course/${id_modulo}/${id_course}`)
      .then(() => {
        swal("Curso removido", "", "success");
        loadMba();
      })
      .catch(() => {
        swal("Erro ao remover curso", "", "success");
      });
  };

  const handleCloseModal = () => {
    setSelectedModalCourse(0);
    setModalModuloId(null);
  };

  const handleAddCourse = async () => {
    if (!selectedModalCourse) {
      swal("Selecione um curso", "", "error");
    }

    try {
      api
        .put("admin/mba/put-course-modulo", {
          modulo_id: modalModuloId,
          curso_id: selectedModalCourse,
          user_id: mba.id_pessoa,
        })
        .then(async () => {
          const logs = {
            local: `admin/mba/list/${id}`,
            texto: `Adicionou um novo curso (${selectedModalCourse}) ao módulo (${modalModuloId}) para o MBA: ${id})`,
          };
          await api.post("system_logs", {
            acao: JSON.stringify(logs),
          });
          handleCloseModal();
          loadMba();
        });
    } catch (error) {
      const logs = {
        local: `admin/mba/list/${id}`,
        texto: `Tentou adicionar um novo curso ao módulo (${modalModuloId}) para o MBA: ${id}) - Erro: ${error}`,
      };
      await api.post("system_logs", {
        acao: JSON.stringify(logs),
      });
      swal("Erro ao criar módulo", "Favor contactar TI", "error");
    }
  };

  const handleRemoveModule = async id_modulo => {
    try {
      api.delete(`/admin/mba/remove-modulo/${id_modulo}`).then(async () => {
        const logs = {
          local: `admin/mba/list/${id}`,
          texto: `Removeu o módulo (${id_modulo}) do MBA: ${id})`,
        };
        await api.post("system_logs", {
          acao: JSON.stringify(logs),
        });
        swal("Módulo deletado", "", "success");
        setConfirmDeleteModal(false);
        loadMba();
      });
    } catch (error) {
      const logs = {
        local: `admin/mba/list/${id}`,
        texto: `Tentou remover o módulo (${id_modulo}) do MBA: ${id}) - Erro: ${error}`,
      };
      await api.post("system_logs", {
        acao: JSON.stringify(logs),
      });
      swal("Erro ao deletar módulo", "Favor contactar TI", "error");
    }
  };

  const handleAddModule = async () => {
    const userId = mba?.id_pessoa;

    const payload = {
      id_mba: id,
      titulo: addModuloModalTitulo,
      data_liberacao: addModuloModalDate,
    };

    if (userId) {
      payload.user_id = userId;
    }

    try {
      api.put("/admin/mba/put-modulo", payload).then(async () => {
        const logs = {
          local: `admin/mba/list/${id}`,
          texto: `Adicionou um novo módulo para o MBA: ${id}) - Payload: ${JSON.stringify(
            payload
          )}`,
        };
        await api.post("system_logs", {
          acao: JSON.stringify(logs),
        });
        setIsAddModuloOpen(false);
        swal("MBA atualizado", "", "success");
        loadMba();
      });
    } catch (error) {
      const logs = {
        local: `admin/mba/list/${id}`,
        texto: `Tentou adicionar um novo módulo para o MBA: ${id}) - Erro: ${error}`,
      };
      await api.post("system_logs", {
        acao: JSON.stringify(logs),
      });
      swal("Erro ao criar módulo", "Favor contactar TI", "error");
    }
  };

  const formatDateToBR = date => {
    const originalDate = new Date(date);

    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    };

    const brazilianDatetime = originalDate.toLocaleString("pt-BR", options);
    return brazilianDatetime;
  };

  const formatDateTime = date => {
    const originalDate = new Date(date);

    const formattedDate = `${originalDate.getFullYear()}-${(
      originalDate.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${originalDate
      .getDate()
      .toString()
      .padStart(2, "0")} ${originalDate
      .getHours()
      .toString()
      .padStart(2, "0")}:${originalDate
      .getMinutes()
      .toString()
      .padStart(2, "0")}:${originalDate
      .getSeconds()
      .toString()
      .padStart(2, "0")}`;

    return formattedDate;
  };

  // Lives
  const handleCloseAddLiveModal = () => {
    setAddLiveDate("");
    setAddLiveDescricao("");
    setAddLiveLink("");
    setAddLiveTipo("youtube_live");
    setAddLiveFile(null);
    setUpdateLiveId(0);
    setIsAddLiveModelOpen(false);
  };

  const handleAddLive = () => {
    if (!addLiveDate || !addLiveLink) {
      swal("Informe todos os campos", "", "error");
      return;
    }

    const formData = new FormData();

    formData.append("file", addLiveFile);
    formData.append("id_mba", id);
    formData.append("link", addLiveLink);
    formData.append("type", addLiveTipo || "youtube_live");
    formData.append("datetime", addLiveDate);
    formData.append("description", addLiveDescricao);

    if (updateLiveId) {
      api
        .put(`/admin/mba/atualiza-live/${updateLiveId}`, formData)
        .then(async () => {
          const logs = {
            local: `admin/mba/list/${id}`,
            texto: `Atualizou a live (${updateLiveId}) para o MBA: ${id})`,
          };
          await api.post("system_logs", {
            acao: JSON.stringify(logs),
          });
          swal("Live atualizada com sucesso", "", "success");
          handleCloseAddLiveModal();
          loadMba();
        })
        .catch(async () => {
          const logs = {
            local: `admin/mba/list/${id}`,
            texto: `Tentou atualizar a live (${updateLiveId}) para o MBA: ${id}) - Erro: ${error}`,
          };
          await api.post("system_logs", {
            acao: JSON.stringify(logs),
          });
          swal(
            "Houve um erro ao adicionar a live",
            "Favor contactar TI",
            "error"
          );
        });
    } else {
      api
        .put("/admin/mba/vincula-live", formData)
        .then(async () => {
          const logs = {
            local: `admin/mba/list/${id}`,
            texto: `Criou a live (${updateLiveId}) para o MBA: ${id})`,
          };
          await api.post("system_logs", {
            acao: JSON.stringify(logs),
          });
          swal("Live adicionada com sucesso", "", "success");
          handleCloseAddLiveModal();
          loadMba();
        })
        .catch(async () => {
          const logs = {
            local: `admin/mba/list/${id}`,
            texto: `Tentou criar uma nova live para o MBA: ${id}) - Erro: ${error}`,
          };
          await api.post("system_logs", {
            acao: JSON.stringify(logs),
          });
          swal(
            "Houve um erro ao adicionar a live",
            "Favor contactar TI",
            "error"
          );
        });
    }
  };

  const handleRemoveLive = async (event, live_id) => {
    event.preventDefault();

    try {
      api.delete(`/admin/mba/remove-live/${live_id}`).then(async () => {
        const logs = {
          local: `admin/mba/list/${id}`,
          texto: `Removeu a live (${live_id}) do MBA: ${id})`,
        };
        await api.post("system_logs", {
          acao: JSON.stringify(logs),
        });
        swal("Live removida", "", "success");
        handleCloseAddLiveModal();
        loadMba();
      });
    } catch (error) {
      const logs = {
        local: `admin/mba/list/${id}`,
        texto: `Tentou remover a live (${live_id}) para o MBA: ${id}) - Erro: ${error}`,
      };
      await api.post("system_logs", {
        acao: JSON.stringify(logs),
      });
      swal("Erro ao remover live", "Favor contactar TI", "error");
    }
  };

  const handleEditLive = (event, live_id) => {
    event.preventDefault();
    const live = mba?.lives.find(live => live_id === live.id);
    setIsAddLiveModelOpen(true);
    setUpdateLiveId(live.id);
    setAddLiveDate(formatDateTimeToLocal(live.datetime, true));
    setAddLiveDescricao(live.description);
    setAddLiveLink(live.link);
    setAddLiveTipo(live.type);
  };

  const formatDateTimeToLocal = (date, isInput) => {
  if (!date) return '';
  
  const originalDate = new Date(date);
  
  const year = originalDate.getFullYear();
  const month = String(originalDate.getMonth() + 1).padStart(2, '0');
  const day = String(originalDate.getDate()).padStart(2, '0');
  const hours = String(originalDate.getHours()).padStart(2, '0');
  const minutes = String(originalDate.getMinutes()).padStart(2, '0');

  if (isInput) {
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  } else {
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }
};

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

      <AdminMenu />
      <Container>
        <Back actualPage={"Editar"} />
        <h1>Editar MBA</h1>

        <form>
          <div>
            <label for="descricao">Descricao:</label>
            <input
              defaultValue={mba.descricao}
              id="descricao"
              onChange={evt => setDescricao(evt.currentTarget.value)}
            ></input>
          </div>

          <div>
            <label for="id_combo">ID Combo:</label>
            <input
              defaultValue={mba.id_combo}
              id="id_combo"
              type="number"
              onChange={evt => setIdCombo(evt.currentTarget.value)}
            ></input>
          </div>

          <div>
            <label for="id_curso">ID Curso:</label>
            <input
              defaultValue={mba.id_curso}
              id="id_curso"
              type="number"
              onChange={evt => setIdCurso(evt.currentTarget.value)}
            ></input>
          </div>

          {mba?.data_validade && (
            <div>
              <label for="id_curso">Data Validade:</label>
              <input
                value={dataValidade}
                id="data_validade"
                type="date"
                onChange={evt => setDataValidade(evt.currentTarget.value)}
              ></input>
            </div>
          )}

          <h2>Lives</h2>

          <Table>
            <Table.Header>
              <Table.HeaderCell>ID</Table.HeaderCell>
              <Table.HeaderCell>Descrição</Table.HeaderCell>
              <Table.HeaderCell>Link</Table.HeaderCell>
              <Table.HeaderCell>Tipo</Table.HeaderCell>
              <Table.HeaderCell>Imagem</Table.HeaderCell>
              <Table.HeaderCell>Data</Table.HeaderCell>
              <Table.HeaderCell>Ações</Table.HeaderCell>
            </Table.Header>

            <Table.Body>
              {mba &&
                mba?.lives?.map(live => (
                  <Table.Row key={live.id}>
                    <Table.Cell>{live.id}</Table.Cell>
                    <Table.Cell>{live.description}</Table.Cell>
                    <Table.Cell>{live.link}</Table.Cell>
                    <Table.Cell>{live.type}</Table.Cell>
                    <Table.Cell>
                      {live.img && (
                        <a target="_blank" href={live.img}>
                          Imagem
                        </a>
                      )}
                    </Table.Cell>
                    <Table.Cell>{formatDateTimeToLocal(live.datetime)}</Table.Cell>
                    <Table.Cell>
                      <ActionButtons>
                        <button
                          onClick={event => handleRemoveLive(event, live.id)}
                        >
                          <RiDeleteBinLine size={16} color="#96989A" />
                        </button>
                        <button
                          onClick={event => handleEditLive(event, live.id)}
                        >
                          <FaRegEdit size={16} color="#96989A" />
                        </button>
                      </ActionButtons>
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </form>

        <Button color="orange" onClick={() => setIsAddLiveModelOpen(true)}>
          Adicionar Live
        </Button>

        <h2>Módulos</h2>

        {mba &&
          mba.mbaModulos &&
          mba.mbaModulos
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((modulo, moduloKey) => (
              <>
                <ModuloHeader key={modulo.id}>
                  <div>
                    <TitleInput
                      value={modulo.titulo}
                      onChange={event =>
                        handleTitleChange(event.target.value, modulo.id)
                      }
                    />

                    <button
                      title="Excluir módulo"
                      onClick={() => {
                        setModuleClicked(modulo.id);
                        setConfirmDeleteModal(true);
                      }}
                    >
                      <RiDeleteBinLine size={20} color="#96989A" />
                    </button>
                  </div>

                  <NumberInput
                    title="Ordenar módulo"
                    type="number"
                    value={modulo.order}
                    min={1}
                    onChange={value =>
                      handleModuloOrdemChange(modulo.id, value.target.value)
                    }
                  />
                </ModuloHeader>

                <Table>
                  <Table.Header>
                    <Table.HeaderCell>ID Curso</Table.HeaderCell>
                    <Table.HeaderCell>Nome</Table.HeaderCell>
                    <Table.HeaderCell>Ordem</Table.HeaderCell>
                    <Table.HeaderCell>Ações</Table.HeaderCell>
                  </Table.Header>

                  <Table.Body>
                    {modulo.moduloCursos
                      .slice()
                      .sort((a, b) => a.order - b.order)
                      .map((curso, cursoKey) => (
                        <Table.Row key={curso.id_curso}>
                          <Table.Cell>{curso.id_curso}</Table.Cell>
                          <Table.Cell>{curso.curso.curso}</Table.Cell>
                          <Table.Cell>
                            <NumberInput
                              type="number"
                              value={curso.order}
                              min={1}
                              onChange={value =>
                                handleCursosOrdemChange(
                                  modulo.id,
                                  curso.id_curso,
                                  value.target.value
                                )
                              }
                            />
                          </Table.Cell>
                          <Table.Cell>
                            <ActionButtons>
                              <button
                                onClick={() =>
                                  handleRemoveCourse(modulo.id, curso.id_curso)
                                }
                              >
                                <RiDeleteBinLine size={16} color="#96989A" />
                              </button>
                            </ActionButtons>
                          </Table.Cell>
                        </Table.Row>
                      ))}
                  </Table.Body>
                </Table>
                <ButtonsWrapper>
                  <div>
                    <Button
                      color="orange"
                      onClick={() => handleRefreshModuloAtualizado(modulo.id)}
                    >
                      Atualizar
                    </Button>
                    <Button
                      color="grey"
                      onClick={() => setModalModuloId(modulo.id)}
                    >
                      Adicionar Curso
                    </Button>
                  </div>
                  <div>
                    <input
                      type="date"
                      defaultValue={modulo?.data_liberacao}
                      onChange={evt =>
                        handleChangeDataLiberacao(
                          modulo.id,
                          evt.currentTarget.value
                        )
                      }
                    />
                  </div>
                </ButtonsWrapper>
              </>
            ))}

        <Bottom>
          <Button color="grey" onClick={() => setIsAddModuloOpen(true)}>
            Adicionar módulo
          </Button>
          <Button color="orange" onClick={() => handleUpdateMBA()}>
            Atualizar
          </Button>
        </Bottom>

        <Modal open={!!modalModuloId} onClose={handleCloseModal}>
          <Modal.Header>Adicionar curso</Modal.Header>
          <Modal.Content>
            <ModalContainer>
              <CursosSelector
                handleChange={value => setSelectedModalCourse(value)}
                is_multiple={true}
              />
            </ModalContainer>
          </Modal.Content>
          <Modal.Actions>
            <ModalActions>
              <Button color="orange" onClick={() => handleAddCourse()}>
                Adicionar Curso
              </Button>
              <Button onClick={handleCloseModal}>Cancelar</Button>
            </ModalActions>
          </Modal.Actions>
        </Modal>

        <Modal open={isAddModuloOpen} onClose={() => setIsAddModuloOpen(false)}>
          <Modal.Header>Adicionar módulo</Modal.Header>
          <Modal.Content>
            <AddModuloModalContainer>
              <div>
                <label>Título: </label>
                <input
                  placeholder="Título"
                  onChange={evt =>
                    setAddModuloModalTitulo(evt.currentTarget.value)
                  }
                />
              </div>
              <div>
                <label>Data liberação: </label>
                <input
                  type="date"
                  placeholder="data liberação"
                  onChange={evt =>
                    setAddModuloModalDate(evt.currentTarget.value)
                  }
                />
              </div>
            </AddModuloModalContainer>
          </Modal.Content>
          <Modal.Actions>
            <ModalActions>
              <Button color="orange" onClick={() => handleAddModule()}>
                Adicionar Módulo
              </Button>
              <Button onClick={() => setIsAddModuloOpen(false)}>
                Cancelar
              </Button>
            </ModalActions>
          </Modal.Actions>
        </Modal>

        <Modal open={isAddLiveModalOpen} onClose={handleCloseAddLiveModal}>
          <Modal.Header>
            {updateLiveId ? "Atualizar Live" : "Adicionar live"}{" "}
          </Modal.Header>
          <Modal.Content>
            <AddModuloModalContainer>
              <div>
                <label>Descrição: </label>
                <input
                  placeholder="Descrição"
                  onChange={evt => setAddLiveDescricao(evt.currentTarget.value)}
                  value={addLiveDescricao}
                />
              </div>
              <div>
                <label>Link: </label>
                <input
                  placeholder="Link"
                  onChange={evt => setAddLiveLink(evt.currentTarget.value)}
                  value={addLiveLink}
                />
              </div>
              <div>
                <label>Data: </label>
                <input
                  type="datetime-local"
                  placeholder="Data"
                  onChange={evt =>
                    setAddLiveDate(formatDateTime(evt.currentTarget.value))
                  }
                  value={addLiveDate}
                />
              </div>
              <div>
                <label>Tipo: </label>
                <select
                  id={"tipo"}
                  onChange={evt => setAddLiveTipo(evt.currentTarget.value)}
                >
                  <option value={"youtube_live"}>youtube_live</option>
                </select>
              </div>
              <div>
                <label>Imagem: </label>
                <input
                  type="file"
                  onChange={event => {
                    console.log({ event: event.target.files[0] });
                    setAddLiveFile(event.target.files[0]);
                  }}
                  accept={".png, .jpeg, .pdf, .jpg"}
                />
              </div>
            </AddModuloModalContainer>
          </Modal.Content>
          <Modal.Actions>
            <ModalActions>
              <Button color="orange" onClick={() => handleAddLive()}>
                {updateLiveId ? "Atualizar live" : "Adicionar Live"}
              </Button>
              <Button onClick={handleCloseAddLiveModal}>Cancelar</Button>
            </ModalActions>
          </Modal.Actions>
        </Modal>

        <Modal
          open={confirmDeleteModal}
          onClose={() => setConfirmDeleteModal(false)}
          centered
        >
          <Modal.Header>Excluir módulo</Modal.Header>
          <Modal.Content>
            <p>Realmente deseja realizar essa exclusão?</p>
          </Modal.Content>
          <Modal.Actions>
            <ModalActions>
              <Button
                color="orange"
                onClick={() => handleRemoveModule(moduleClicked)}
              >
                Excluir agora
              </Button>
              <Button onClick={() => setConfirmDeleteModal(false)}>
                Cancelar
              </Button>
            </ModalActions>
          </Modal.Actions>
        </Modal>
      </Container>
    </div>
  );
};
